import { impactLabel, likelihoodLabel, seriousnessClass, seriousnessLabel, WarningEvent } from '../../restapi/types';
import React from 'react';
import { Tooltip } from '@wfp/ui';

import "./SeriousnessDot.scss";


interface Props {
	event: WarningEvent;
}

export function SeriousnessDot({event}: Props) {
	return <div className="seriousness-dot">
		<Tooltip dark trigger="hover" placement="top"
				 createRefWrapper={true}
				 content={(<div>
					 <p className="no-wrap">Seriousness: <strong>{seriousnessLabel[event.seriousness]}</strong></p>
					 <p className="no-wrap">Likelihood: <strong>{likelihoodLabel[event.likelihood]}</strong></p>
					 <p className="no-wrap">Impact: <strong>{impactLabel[event.impact]}</strong></p>
				 </div>)}>
			<div className={'dot-content ' + seriousnessClass[event.seriousness]}/>
		</Tooltip>
	</div>;
}